import Component from "../../component";

export default class VpVolumeBar extends Component {
  constructor(player, options = {}) {
    super(player, options);
    this._player = player;
    this.sliderInput;
    this.sliderProgress;
    this.width = 96; //get slider width, change this if you change the css due to inability to read the element width
    this.initStart();
  }

  createEl() {
    let container = super.createEl("div");
    container.classList.add('vjs-volume-slider');
    container.innerHTML = `
      <input class="vjs-volume-slider--input" type="range" min="0" value="100" max="100">
      <div class='vjs-volume-slider--full'>
        <div class='vjs-volume-slider--progress'></div>
      </div>
    `;

    return container;
  }

  initStart() {
    this.on(this.player(), 'loadstart', this.setInitialValue.bind(this));
    this.on(this.player(), 'loadstart', this.bindSliderChange.bind(this));
    this.on(this.player(), 'loadstart', this.handleVolumeChange.bind(this));
    this.on(this.player(), 'volumechange', this.handleVolumeChange.bind(this));
  }

  setInitialValue() {
    this.sliderInput = this.el().getElementsByClassName('vjs-volume-slider--input')[0];
    this.sliderProgress = this.el().getElementsByClassName('vjs-volume-slider--progress')[0];
    var initialValue = `${this.sliderInput.value * this.width / 100}px`;

    this.sliderProgress.style.width = initialValue;
  }

  bindSliderChange() {
    this.sliderInput.addEventListener('input', this.handleSliderChange.bind(this));
  }

  handleSliderChange(e) {
    var value = e.target.value;
    this.sliderProgress.style.width = `${value * this.width / 100}px`;
    this.player().volume(value / 100);

    if (value > 0) {
      this.player().muted(false);
    } else {
      this.player().muted(true);
    }
  }

  handleVolumeChange() {
    if(this.player().muted()){
      this.sliderInput.value = '0';
      this.sliderInput.title = "";
      this.sliderProgress.style.width = '0px';
    } else {
      this.sliderInput.value = this.player().volume() * 100;
      this.sliderInput.title = "";
      this.sliderProgress.style.width = `${this.width * this.player().volume()}px` ;
    }
  }

  player() {
    return this._player;
  }
}
